var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"d-flex flex-column align-start",attrs:{"pa-0":"","fluid":"","fill-height":""}},[_c('FullHeader'),_c('v-container',{staticClass:"pa-0",staticStyle:{"display":"flex","flex-grow":"1","max-height":"100%","height":"200px"},attrs:{"fluid":""}},[_c('EntryPoint')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }